import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { Subscription } from 'rxjs';
import { NotificationModel } from 'src/app/models/common.model';
import { UserModel } from 'src/app/models/profile.model';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as SgeCrypto from 'src/assets/lib/sge/sge-crypto';

import { CommonService } from './common.service';
import { NotificationService } from './notification.service';
@Injectable({
  providedIn: 'root',
})
export class SafeLockService {
  subscription = new Subscription();
  user!: UserModel;

  constructor(private keycloak: KeycloakService, private notificationService: NotificationService, private router: Router, private commonService: CommonService) {}

  enableSafeLock(email: string, password: string): Promise<any> {
    return new Promise((resolve, reject) => {
      SgeCrypto.unlockCrypto(email, password)
        .then(
          (result: any) => {
            if (result) {
              const notification = {
                message: this.commonService.getTranslatedMessage('YOU_ENTERED_SUCCESSFULLY'),
              };
              this.notificationService.successNotification(notification);
              resolve(true);
            } else {
              const notification: NotificationModel = {
                message: this.commonService.getTranslatedMessage('YOU_ENTERED_WRONG_PASSWORD'),
              };
              this.notificationService.errorNotification(notification);
            }
            reject();
          },
          () => {
            const notification: NotificationModel = {
              message: this.commonService.getTranslatedMessage('YOU_ENTERED_WRONG_PASSWORD'),
            };
            this.notificationService.errorNotification(notification);

            reject();
          },
        )
        .catch(() => {
          const notification: NotificationModel = {
            message: this.commonService.getTranslatedMessage('YOU_ENTERED_WRONG_PASSWORD'),
          };
          this.notificationService.errorNotification(notification);
        });
    });
  }

  isSafelockActivated(email: string): Promise<any> {
    return SgeCrypto.isRegisteredToSecureStorage(email);
  }

  isValidCryptoPassword(password: string): void {
    SgeCrypto.validateCryptoPassword(password);
  }
}
